import { defineComponent as d, computed as o, openBlock as c, createElementBlock as i, createElementVNode as t, toDisplayString as n, createCommentVNode as _, normalizeStyle as h } from "vue";
const m = ["viewBox"], f = /* @__PURE__ */ t("mask", { id: "dbc4e097-8674-4725-ac54-16db9a786edd" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#dbc4e097-8674-4725-ac54-16db9a786edd)" }, k = { key: 0 }, p = /* @__PURE__ */ t("path", {
  fill: "#d80027",
  d: "M0 0h512v512H0z"
}, null, -1), g = /* @__PURE__ */ t("path", {
  fill: "#eee",
  d: "m350.8 171.6-18.1 64.6-54.3-10-35-72-94.4 33.4-7.4-21-24.7-3 18.6 52.5 65-16.7 18.4 52-44.9 66.3 76.3 65-14.5 17 9.7 22.9 36.1-42.3-46.8-48 35.8-42 79.8 5.8 18.2-98.6 22 4 15-19.8-54.8-10zM256 256z"
}, null, -1), v = { fill: "none" }, x = ["r"], z = /* @__PURE__ */ d({
  __name: "im",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const e = r, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), a = o(() => 256 + e.strokeWidth / 2);
    return (w, y) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      f,
      t("g", u, [
        e.flagName ? (c(), i("title", k, n(e.flagName), 1)) : _("", !0),
        p,
        g
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, m));
  }
});
export {
  z as default
};
//# sourceMappingURL=im-70518788.js.map
